module.exports = __webpack_public_path__ + "img/hbl.f7320699.jpg";